import { render } from "./Controller.vue?vue&type=template&id=2f328e4a&scoped=true"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"

import "./Controller.vue?vue&type=style&index=0&id=2f328e4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f328e4a"]])

export default __exports__